import { OptionType } from 'components/UI/SelectField';
import { APIError } from 'models';

export type SelectableSoftware = {
  softwares: OptionType[] | null;
  isLoading: boolean;
  error: APIError | null;
};

export type SoftwareUpdate = {
  id: string;
  type: string;
  attributes: {
    software: string;
    status: string;
    lastModifiedAt: number;
    statusMessage: string;
    updateType: string;
    detailStatus: string;
    statusReports: StatusReport[];
  };
};

export type StatusReport = {
  type: string;
  message: string;
  reportedAt: number;
  id: number;
};

export type SoftwareUpdateData = {
  softwareUpdates: SoftwareUpdate[];
  lastEvaluatedId: string | null;
  nextOffset: number;
  isLoading: boolean;
  error: APIError | null;
  totalCount: number;
};

export type SoftwareUpdateState = {
  selectableSoftware: SelectableSoftware;
  softwareUpdatesData: SoftwareUpdateData;
};

export type SelectableSoftwareSuccess = {
  response: OptionType[];
};

export type SoftwareUpdatesSuccess = {
  softwareUpdates: SoftwareUpdate[];
  totalSoftwareUpdates: number;
  lastEvaluatedId?: string;
  nextOffset: number;
};

export type getSoftwareUpdatesFailure = {
  error: APIError;
  totalSoftwareUpdates: number;
};

export type SoftwareUpdateMeta = {
  totalCount: number;
  lastEvaluatedId?: string;
  nextOffset?: number;
};

export type SoftwareUpdatesResponse = {
  data: SoftwareUpdate[];
  meta: SoftwareUpdateMeta;
  errors?: APIError;
};

export type AssignSoftwareRequest = {
  data: {
    type: string;
    attributes: {
      softwareId: string;
    };
  };
};

export interface AssignSoftwareResponse {
  data: {
    attributes: {
      softwareUpdateId: string;
    };
  };
  errors?: APIError[];
}

export enum AssignSoftwareAttribute {
  SOFTWARE = 'software',
}
